/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import bucanero from '../../../Recursos/bucanero.png'
import campollo from '../../../Recursos/campollo.png'
import refisal from '../../../Recursos/refisal.png'
import uno from '../../../Recursos/uno.png'
import dos from '../../../Recursos/dos.png'
import tres from '../../../Recursos/tres.png'
import cuatro from '../../../Recursos/cuatro.png'
import cino from '../../../Recursos/cinco.png'
import seis from '../../../Recursos/seis.png'
import siete from '../../../Recursos/siete.png'
import {Splide, SplideSlide} from '@splidejs/react-splide';
import {theme} from "../../../Tema";

const marcas = [
    {
        urlimagen: bucanero,
        alt: 'Descripción de la imagen 1',
    },
    {
        urlimagen: campollo,
        alt: 'Descripción de la imagen 2',
    },
    {
        urlimagen: refisal,
        alt: 'Descripción de la imagen 3',
    },
    {
        urlimagen: uno,
        alt: 'Descripción de la imagen 1',
    },
    {
        urlimagen: dos,
        alt: 'Descripción de la imagen 2',
    },
    {
        urlimagen: tres,
        alt: 'Descripción de la imagen 3',
    },
    {
        urlimagen: cuatro,
        alt: 'Descripción de la imagen 3',
    },
    {
        urlimagen: cino,
        alt: 'Descripción de la imagen 3',
    },
    {
        urlimagen: seis,
        alt: 'Descripción de la imagen 3',
    },
    {
        urlimagen: siete,
        alt: 'Descripción de la imagen 3',
    },

];


const Marcas_Home = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container justifyContent={'center'}
                  alignItems={'center'}
                  size={{xs: 12, sm: 3, md: 3}}>
                <Typography variant="h6" component="h3"
                            sx={{
                                marginY: {xs: 0, sm: 3, md: 4},
                                paddingY: {xs: 3, sm: 0, md: 0},
                                paddingX: 1,
                                paddingRight: 3,
                                color: theme.palette.primary.main,
                                fontSize: 24,
                                fontWeight: 900,
                                borderRight: {xs: 'none', sm: '4px solid', md: '4px solid'},
                                borderBottom: {xs: '4px solid', sm: 'none', md: 'none'},
                                borderColor: theme.palette.primary.main,
                                lineHeight: 1.1
                            }}>
                    Marcas que trabajan con nosotros
                </Typography>
            </Grid>

            <Grid container justifyContent={'flex-start'} size={{xs: 12, sm: 9, md: 9}}
                  spacing={0}
                  sx={{paddingX: 4}}>
                <Splide
                    aria-label="My Favorite Images"
                    options={{
                        arrows: false,
                        pagination: false,
                        autoplay: true,
                        interval: 3000,
                        width: '100%',
                        type: 'loop',
                        perPage: 3,  // 3 items per page for larger screens
                        perMove: 1,
                        gap: '1rem',  // Ajuste del espacio entre los elementos
                        breakpoints: {
                            600: {  // En pantallas menores a 600px (típicamente dispositivos móviles)
                                perPage: 2,  // Mostrar 1 item por página
                                gap: '1rem',  // Ajustar el espacio entre los elementos
                            },
                        },
                    }}
                >
                    {marcas.map((marca, index) => (
                        <SplideSlide key={index}>
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'center'}
                                size={{xs: 12, sm: 12, md: 8}} // Tamaño responsivo
                                sx={{paddingY: 3}}
                            >
                                <img
                                    src={marca.urlimagen}
                                    alt={marca.alt}
                                    style={{
                                        width: '100%',
                                        height: 'auto'
                                    }} // Asegura que las imágenes se ajusten al contenedor
                                />
                            </Grid>
                        </SplideSlide>
                    ))}
                </Splide>

            </Grid>
        </Grid>
    )
}
export default Marcas_Home

